export const GHAT_IMAGES = {
  GUPTAR_GHAT: {
    GALLERY: [
      '/images/ghats/guptar-ghat/1.jpg',
      '/images/ghats/guptar-ghat/2.jpg',
    ],
    THUMBNAIL: '/images/ghats/guptar-ghat/1.jpg'
  },
  SARYU_GHAT: {
    GALLERY: [
      '/images/ghats/saryu-ghat-1.jpeg',
    ],
    THUMBNAIL: '/images/ghats/saryu-ghat-1.jpeg'
  },
  NAYA_GHAT: {
    GALLERY: [
      '/images/ghats/naya-ghat-1.jpg',
    ],
    THUMBNAIL: '/images/ghats/naya-ghat-1.jpg'
  },
  LAKSHMAN_GHAT: {
    GALLERY: [
      '/images/ghats/lakshman-ghat-1.jpg',
    ],
    THUMBNAIL: '/images/ghats/lakshman-ghat-1.jpg'
  },
  KAUSHALYA_GHAT: {
    GALLERY: [
      '/images/ghats/kaushalya-ghat-1.jpeg',
      '/images/ghats/kaushalya-ghat-2.jpeg',
      '/images/ghats/kaushalya-ghat-3.jpg',
    ],
    THUMBNAIL: '/images/ghats/kaushalya-ghat-1.jpeg'
  },
  JHUNKI_GHAT: {
    GALLERY: [
      '/images/ghats/jhunki-ghat-1.jpg',
    ],
    THUMBNAIL: '/images/ghats/jhunki-ghat-1.jpg'
  },
  TULSI_GHAT: {
    GALLERY: [
      '/images/ghats/tulsi-ghat-1.jpg',
      '/images/ghats/tulsi-ghat-2.jpg',
    ],
    THUMBNAIL: '/images/ghats/tulsi-ghat-1.jpg'
  },
  GAU_GHAT: {
    GALLERY: [
      '/images/ghats/gau-ghat-2.jpg',
      '/images/ghats/gau-ghat-1.jpg'
    ],
    THUMBNAIL: '/images/ghats/gau-ghat-2.jpg'
  },
};
